export const statusOptions = [
  { value: 'todos', title: 'Todos' },
  { value: 'activos', title: 'Activos' },
  { value: 'inactivos', title: 'Inactivos' }
];
